export const GOOGLE_MAPS_API_KEY = 'AIzaSyBgKy8NWXLhXaCmYMakkZusJ0ZwfiE-aEc';

export const TYPE_SEEDING_RATE = 'seedingRate';
export const TYPE_POPULATION = 'population';
